
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ReceiveTasks/ReceiveTasks.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ReceiveTasks.html');
        
        var script = require('./ReceiveTasks.ts').default;
        module.exports = require('./ReceiveTasks.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    